import { combineReducers } from "@reduxjs/toolkit";
import ototransTransaksiReducer from "./transaction";
import ototransPartnerReducer from "./partner";

const ototransReducers = combineReducers({
    partner: ototransPartnerReducer,
    transaksi: ototransTransaksiReducer
})

export default ototransReducers